import React, { useState, useEffect } from 'react';
import { Link, useHistory } from 'react-router-dom';
import arrow_back from '../assets/images/arrow-back.svg';
import logo_pop from '../assets/images/logo-pop.png';
import SingleItem from '../components/singleItem';
import ProfileHeader from '../components/ProfileHeader';
import { useDispatch, useSelector } from 'react-redux';
import { setCurseHadings } from '../reducers/reposReducers';
import ApiService from '../services/ApiService';
import EDSFooter from '../components/EDSFooter';

const Wybor_opcji_3_wariant = () => {
    const key = useSelector((state) => state.repos.chName);
    if (!key || key == '') {
  
        history.push(`/LoginBuy/key=${localStorage.getItem('keyURL')}`);
    }

    const apiService = ApiService.getInstance();
    const history = useHistory();
    const startDate = useSelector((state) => state.repos.date);
    const getGroup = useSelector((state) => state.repos.groups);
    const coursesHeadings = useSelector((state) => state.repos.coursesHeadings);
    const dispatch = useDispatch();
    const usersParticipant = useSelector((state) => state.repos.usersParticipant);
    const users = useSelector((state) => state.repos.users);
    const [selectedItem, setSelectedItem] = useState(0);
    const [entryFee, setEntryLocalFee] = useState('0');
    const [res, setRes] = useState([]);
    const [openMonth, setOpenMonth] = useState(false);
    const [formData] = useState({
        courseHeadingName: useSelector((state) => state.repos.chName), // 'Żwiry-K1', // TODO będzie przychodić w linku w gecie
        attendanceStartDate: `${startDate}`,
        current_LocalizationsID: '0',
    });

    const [CheckUserEntryFeeParams] = useState({
        usersID: usersParticipant ? usersParticipant.usersID : users ? users.usersID : '', // 'Żwiry-K1', // TODO będzie przychodić w linku w gecie
        localizationsID: coursesHeadings.localizationsID,
        current_LocalizationsID: '0',
    });

    let state = false;
    let productsID = getGroup.productsID;
    let responseCoursesHeadingsID;

    const methodCheckUserEntryFee = async () => {
        await apiService
            .asyncApiPost('CheckUserEntryFee', CheckUserEntryFeeParams)
            .then((response) => {
                setEntryLocalFee(
                    response.responseBody.body.price
                        ? response.responseBody.body.price.toString()
                        : null
                );
            });

        return 'Finished methodCheckUserEntryFee';
    };

    const methodGetCourseWWWInfo = async () => {
        await apiService.asyncApiPost('GetCourseWWWInfo', formData).then((response) => {
            dispatch(setCurseHadings(response.responseBody.body));
            localStorage.setItem('coursesHeadings', JSON.stringify(response.responseBody.body));

            localStorage.setItem('coursesHeadingsID', response.responseBody.body.coursesHeadingsID);
            responseCoursesHeadingsID = response.responseBody.body.coursesHeadingsID;
        });

        return 'Finished methodGetCourseWWWInfo';
    };

    const methodGetPriceByCourseHeadingsID = async () => {
        await apiService
            .asyncApiPost('GetPriceByCourseHeadingsID', {
                coursesHeadingsID: responseCoursesHeadingsID,
                current_LocalizationsID: '0',
                startDate: `${startDate}`,
            })
            .then((response) => {
                if (response.body.length != 0) {
                    let dataSort = response.body.sort(function (a, b) {
                        if (a.paymentTypesDVID > b.paymentTypesDVID) {
                          return 1;
                        }
                        if (a.paymentTypesDVID < b.paymentTypesDVID) {
                          return -1;
                        }
                        return 0;
                      });
                      response.body.map(e => {
                        if(e.periodsOfValidityDVID === 3){
                            setOpenMonth(true);
                         } 
                      })
                    
                    // let sortRespons = response.body
                    setRes(dataSort);
                } else {
                    history.push('/Error_ogolny');
                }
            });

        return 'Finished methodGetPriceByCourseHeadingsID';
    };

    const save = () => {
        history.push('/Wybor_opcji_4_forma_platnosci');
    };

    useEffect(async () => {
        await methodGetCourseWWWInfo();
        await methodGetPriceByCourseHeadingsID();
        await methodCheckUserEntryFee();
    }, []);

    return (
        <>
            <header className="header">
                <div className="header__image-box">
                    <a href="">
                        <img
                            src={logo_pop}
                            alt="Logo Egurrola Dance Studio"
                            className="header__image"
                        />
                    </a>
                </div>
                <div className="header__caption-box">
                    <span className="header__caption">
                        Proces zakupu kursu: {localStorage.getItem('courseHeadingName')}
                    </span>
                </div>
            </header>
            <div className="content">
                <a href="#">
                    <Link to="/Wybor_opcji_2_data">
                        <img src={arrow_back} alt="arrow_back" className="arrow-back" />
                    </Link>
                </a>
                <ProfileHeader></ProfileHeader>
                <aside className="registration-steps margin-top-32">
                    <div className="step">
                        <div className="step__circle step__circle--active">
                            <span className="step__count">1</span>
                        </div>
                        <span className="step__text">Wybór&nbsp;kursu</span>
                    </div>
                    <div className="step">
                        <div className="step__circle">
                            <span className="step__count">2</span>
                        </div>
                        <span className="step__text">Umowa</span>
                    </div>
                    <div className="step">
                        <div className="step__circle">
                            <span className="step__count">3</span>
                        </div>
                        <span className="step__text">Płatność</span>
                    </div>
                </aside>
                <aside className="registration-course-steps margin-top-16">
                    <span className="step">Uczestnik</span>
                    <div className="hyphen"></div>
                    <span className="step">Data</span>
                    <div className="hyphen"></div>
                    <span className="step step--active">Wariant</span>
                    <div className="hyphen"></div>
                    <span className="step">Forma płatności i rabat</span>
                    <div className="hyphen"></div>
                    <span className="step">Raty</span>
                </aside>
                <main className="responsive-padding">
                    <section className="course-options-variant margin-top-64">
                        <h2 className="h2">Wariant</h2>
                        <form
                            id="course-options-variant-form"
                            className="margin-top-32"
                            method="post"
                            action=""
                            onSubmit={(e) => save(e)}
                        >
                            <fieldset className="price-variants">
                                <h3 className="h3">Wybierz wariant cenowy</h3>
                                <ul className="price-variants__list margin-top-16">
                                    <div className="price-variants__caption">
                                        <p className="price-variants__caption-title">
                                            Umowa Roczna
                                        </p>
                                        <div className="price-variants__caption-line"></div>
                                    </div>
                                    <div className="price-variants__list-row">
                                        {res.map((el) =>
                                            el.periodsOfValidityDVID === 1 ? (
                                                <SingleItem
                                                    key={el.productsID}
                                                    groups={el}
                                                    productsID={el.productsID}
                                                    currentPrice={el.currentPrice}
                                                    unitAmount={el.unitAmount}
                                                    name={(el.paymentTypesDVID === 1)? 'z góry': 'ratalna'}
                                                    priceListPositionName={el.priceListPositionName}
                                                    expirationDateTo={el.expirationDateTo}
                                                    setSelectedItem={setSelectedItem}
                                                    state={
                                                        productsID == el.productsID ? true : state
                                                    }
                                                    entryFee={entryFee}
                                                />
                                            ) : (
                                                ''
                                            )
                                        )}
                                    </div>
                                    <div className="price-variants__caption">
                                        <p className="price-variants__caption-title">
                                            Umowa Semestralna
                                        </p>
                                        <div className="price-variants__caption-line"></div>
                                    </div>
                                    <div className="price-variants__list-row">
                                        {res.map((el) =>
                                            el.periodsOfValidityDVID === 2 ? (
                                                <SingleItem
                                                    key={el.productsID}
                                                    productsID={el.productsID}
                                                    currentPrice={el.currentPrice}
                                                    groups={el}
                                                    unitAmount={el.unitAmount}
                                                    name={(el.paymentTypesDVID === 1)? 'z góry': 'ratalna'}
                                                    priceListPositionName={el.priceListPositionName}
                                                    expirationDateTo={el.expirationDateTo}
                                                    setSelectedItem={setSelectedItem}
                                                    state={
                                                        productsID == el.productsID ? true : state
                                                    }
                                                    entryFee={entryFee}
                                                />
                                            ) : (
                                                ''
                                            )
                                        )}
                                    </div>
                                    {openMonth ?
                                        <div >
                                        <div className="price-variants__caption">
                                            <p className="price-variants__caption-title">
                                                Umowa miesięczna
                                            </p>
                                            <div className="price-variants__caption-line"></div>
                                        </div>
                                        <div className="price-variants__list-row">
                                            {res.map((el) =>
                                                el.periodsOfValidityDVID === 3 ? (
                                                    <SingleItem
                                                        key={el.productsID}
                                                        productsID={el.productsID}
                                                        currentPrice={el.currentPrice}
                                                        groups={el}
                                                        unitAmount={el.unitAmount}
                                                        name={(el.paymentTypesDVID === 1) ? 'z góry' : 'ratalna'}
                                                        priceListPositionName={el.priceListPositionName}
                                                        expirationDateTo={el.expirationDateTo}
                                                        setSelectedItem={setSelectedItem}
                                                        state={
                                                            productsID == el.productsID ? true : state
                                                        }
                                                        entryFee={entryFee}
                                                    />
                                                ) : (
                                                    ''
                                                )
                                            )}
                                        </div>
                                    </div> : ''
                                    }
                                    
                                    
                                </ul>
                            </fieldset>
                            <input
                                type="submit"
                                className={`btn-primary margin-top-64 margin-bottom-32 ${
                                    selectedItem === 0 && productsID === 0 ? 'button-disabled' : ''
                                }`}
                                value="Dalej"
                            />
                        </form>
                    </section>
                </main>
                {/* <div>
                    <button onClick={() => onCountClick()}>click</button>
                </div> */}
            </div>
            <EDSFooter></EDSFooter>
        </>
    );
};
export default Wybor_opcji_3_wariant;
